import type { BreadcrumbProps } from 'antd/lib/breadcrumb';
import Breadcrumb from 'antd/lib/breadcrumb';
import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';

export const StyledBreadcrumb: StyledComponent<typeof Breadcrumb, BreadcrumbProps> = styled(
  Breadcrumb,
)`
  &.active {
    font-weight: bold;
  }
`;
